module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-he.2ad16739.png";